import { render, staticRenderFns } from "./Approved.vue?vue&type=template&id=37ca417d&scoped=true"
import script from "./Approved.vue?vue&type=script&lang=js"
export * from "./Approved.vue?vue&type=script&lang=js"
import style0 from "./Approved.vue?vue&type=style&index=0&id=37ca417d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca417d",
  null
  
)

export default component.exports